module.exports = __webpack_public_path__ + "f7ca84dd59f987d4d4208294861f2c0a.png";